<template>
    <section class="userOrders">
      <v-container
      class=""
      >
        <v-subheader class="mb-4  darken-4 rounded">{{$t("userOrders.title")}}</v-subheader>
        <v-expansion-panels :popout='true' dark
        v-if="myOrders"
        >
         <v-expansion-panel
          v-for="(order,index) in myOrders" :key="index"
         >
           <v-expansion-panel-header>
            <p class="font-weight-bold">{{$t("userOrders.orderId")}} {{order.id}} <br> 
            <span class="text-caption font-weight-regular mt-1">{{$t("userOrders.orderAt")}} {{order.date}}</span></p>
            <p class="text-caption green--text">{{$t("userOrders.message.succsse")}} 
             <v-icon small color="green">fa fa-check-circle</v-icon></p>
           </v-expansion-panel-header>
           <v-expansion-panel-content>
           <v-simple-table dark>
            <thead class="text-center">
            <tr>
                <th>{{$t("orders.facteur.items")}}</th>
                <th class="pe-7">{{$t("orders.facteur.quantite")}}</th>
                <th>{{$t("orders.facteur.price")}}</th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(item,index) in order.orderContent" :key="index">
            <td class="pt-1 pb-1">
            <v-avatar size="44">
              <img alt="image" :src="require(`@/assets/food/${item.type}/${item.img}`)">
            </v-avatar>
            <span class="pl-3 pr-3 font-weight-bold text-caption" v-text="item.name"></span>
            </td>
            <td v-text="item.quantite"></td>
            <td>{{item.price}}$</td>
            </tr>
            <tr>
             <td colspan="2" class="text-center text-caption font-weight-bold">{{$t("orders.facteur.total")}}</td>
             <td  >{{order.totalPrice}} $</td>
            </tr>
            </tbody>
         </v-simple-table>
           </v-expansion-panel-content>
         </v-expansion-panel>
        </v-expansion-panels>
        <section  v-else class="text-center d-flex justify-center flex-column" style="width:100%;height: 64vh;">
         <p class=" font-weight-bold ">{{$t("userOrders.message.warning")}}</p>
         <div>
         <v-btn link to='/' outlined elevation="0" dark class="ml-3 mr-3" color="red">{{$t("userOrders.links.home")}}</v-btn>
         <v-btn color="black" dark  link to='/order'>{{$t("userOrders.links.order")}}</v-btn>
         </div>
        </section>
      </v-container>
    </section>
</template>

<script>
export default {
    name:'userOrders',
    data() {
        return {
            myOrders:[
                {
                    id:'jqkqjks',
                    date:'24-12-2009 12:00 am',
                    status:'deliverd',
                    totalPrice:'121',
                    orderContent:[
                        {
                            name:'pizza',
                            img:'pizza.png',
                            price:'21',
                            quantite:'4',
                            type:'pizza'
                        }
                    ]
                },
                {
                    id:'jqkqjks',
                    date:'24-12-2009 12:00 am',
                    status:'deliverd',
                    totalPrice:'121',
                    orderContent:[
                        {
                            name:'pizza',
                            img:'pizza.png',
                            price:'21',
                            quantite:'4',
                            type:'pizza'
                        }
                    ]
                }
            ]
        }
    },
}
</script>